import { FC } from 'react';
import { ellipsis } from '@/_utils/strings';
import { Flex, Text, Icon } from '@/_components';
import { SelectedFirmIndicatorProps } from './SelectedFirmIndicator.types';

export const SelectedFirmIndicator: FC<SelectedFirmIndicatorProps> = ({
  title = '',
}) => {
  return (
    <Flex isYCentered={true} gap={2}>
      <Icon size={14} name="buildings" />
      <Text type="tiny" color="secondary" className="flex mobile:hidden">
        {ellipsis(title, 12, 'middle')}
      </Text>
    </Flex>
  );
};
